<div class="">
  <h1 class="h4 text-uppercase">Login</h1>
  <p>
    Geben Sie Ihre E-Mail-Adresse und Ihr Passwort ein und klicken Sie auf <strong>„Anmelden“</strong>.<br>
    Bei aktivierter Zwei-Faktor-Authentifizierung (2FA) geben Sie anschließend den aktuellen 6-stelligen Code aus Ihrer
    Authenticator-App ein.
  </p>
</div>

<div class="mt-5">
  <h1 class="h4 text-uppercase">2-Faktor-Login Aktivieren</h1>
  <ol>
    <li>Klicken Sie auf <strong>„2-Faktor-Login aktivieren“</strong>.</li>
    <li>Scannen Sie den angezeigten <strong>QR-Code</strong> mit Ihrer Authenticator-App.</li>
    <li>
      Geben Sie den erzeugten <strong>6-stelligen Code</strong> im Feld „Einmal-Passwort“ ein und bestätigen Sie. Nach
      erfolgreicher Aktivierung werden Sie automatisch zum Dashboard weitergeleitet.
    </li>
  </ol>
</div>

<div class="mt-5">
  <h1 class="h4 text-uppercase">Passwort zurücksetzen</h1>
  <p>
    Klicken Sie auf der Login-Seite auf <strong>„Passwort vergessen“</strong>.<br>
    Geben Sie Ihre E-Mail-Adresse ein und fordern Sie ein neues Passwort an.<br>
    Über den Link in der erhaltenen E-Mail können Sie ein neues Passwort festlegen und sich anschließend wieder einloggen.<br>
  </p>
</div>

<div class="mt-2 text-center">
  <button class="btn btn-secondary" (click)="back()">Zurück</button>
</div>
